import React from 'react';

import UTErrorScreen from '..';

const WithErrorWrapper = (shouldShowMessage, message) => WrappedComponent => {
  const WithError = props =>
    shouldShowMessage(props) ? (
      <UTErrorScreen mssg={message} totalHeight noElements />
    ) : (
      <WrappedComponent {...props} />
    );
  return WithError;
};

export default WithErrorWrapper;
